var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ProtectionMask50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M15,27c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S15,24.8,15,27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M41,27c0-2.2-1.8-4-4-4s-4,1.8-4,4s1.8,4,4,4S41,29.2,41,27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M10,19c0-12.7,28-10.3,28-2v13c0,8.3-8.2,15-14,15s-14-6.7-14-15V19z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M8,19.3c0.5-6,1.7-11.9,9-13.3l2-3h5c9.2,0,16,7.5,16,18v3.4L37,28c0,0,0,0.5,0-6 c0-10.5-13.5,4.4-20-9c-0.3,5.5-6,8-6,8v7l-3-3.6V21C8,20.4,7.9,19.9,8,19.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M33,28c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2C32.1,26,33,26.9,33,28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M19,28c0-1.1-0.9-2-2-2s-2,0.9-2,2s0.9,2,2,2S19,29.1,19,28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2ebf2",
    d: "M34,31v8.75C31.12,42.97,27.2,45,24,45s-7.12-2.03-10-5.25V31c0,0,5,2,10,2S34,31,34,31z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2ebf2",
    d: "M34,35.063l6.885-9.012C40.629,24.929,40,24.361,40,24.361L34,31V35.063z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2ebf2",
    d: "M14,35.063L7.115,26.05C7.371,24.929,8,24.361,8,24.361L14,31V35.063z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ProtectionMask50);
export default __webpack_public_path__ + "static/media/icons8-protection-mask-50.480708b42f475bd0e811c4add6cfe8c9.svg";
export { ForwardRef as ReactComponent };